import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { FileText, Loader2 } from "lucide-react";
import api from "@/lib/api";
import Markdown from "@/components/Markdown";

export default function LegalPage() {
  const { slug } = useParams();
  const [doc, setDoc] = useState(null);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    setDoc(null);
    api.get(`/legal/${slug}`).then((r) => setDoc(r.data)).catch(() => setNotFound(true)).finally(() => setLoading(false));
    api.get("/legal").then((r) => setList(r.data)).catch(() => {});
  }, [slug]);

  const updated = doc?.updated_at ? new Date(doc.updated_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" }) : null;

  return (
    <div className="mx-auto max-w-6xl px-5 py-14 lg:px-8 lg:py-20" data-testid="legal-page">
      <div className="grid gap-10 lg:grid-cols-[240px_1fr]">
        <aside className="lg:sticky lg:top-24 lg:self-start" data-testid="legal-nav">
          <p className="overline mb-3 text-[color:var(--ink-muted)]">Legal</p>
          <nav className="grid gap-1">
            {list.map((d) => (
              <Link
                key={d.slug}
                to={`/legal/${d.slug}`}
                data-testid={`legal-link-${d.slug}`}
                className={`rounded-lg px-3 py-2 text-sm transition-colors ${
                  d.slug === slug
                    ? "bg-[color:var(--evergreen-soft)] font-medium text-[color:var(--evergreen)]"
                    : "text-[color:var(--ink-body)] hover:bg-[color:var(--paper-soft)]"
                }`}
              >
                {d.title}
              </Link>
            ))}
          </nav>
        </aside>

        <main className="min-w-0">
          {loading ? (
            <div className="flex items-center gap-2 py-24 text-[color:var(--ink-muted)]"><Loader2 className="animate-spin" size={18} /> Loading…</div>
          ) : notFound ? (
            <div className="py-24 text-center" data-testid="legal-not-found">
              <FileText className="mx-auto text-[color:var(--ink-muted)]" size={28} />
              <h1 className="mt-4 font-editorial text-2xl text-[color:var(--ink)]">Document not found</h1>
              <p className="mt-2 text-sm text-[color:var(--ink-body)]">This legal document isn't available.</p>
            </div>
          ) : (
            <article>
              {updated && <p className="overline mb-3 text-[color:var(--ink-muted)]" data-testid="legal-updated">Last updated · {updated}</p>}
              <div className="text-[15px] text-[color:var(--ink)]" data-testid="legal-body">
                <Markdown>{doc.body}</Markdown>
              </div>
            </article>
          )}
        </main>
      </div>
    </div>
  );
}
